




















export default {
    name: 'CoSwitch',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        // Give icon-only switches a programmatic name when no visible label is associated with the input.
        accessibleLabel: {
            type: String,
            default: null,
        },
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    data() {
        return {
            model: this.value,
        };
    },
    watch: {
        value(val) {
            this.model = val;
        },
    },
    mounted() {
        this.model = this.value;
    },
    methods: {
        toggle(e) {
            if (this.disabled) {
                return;
            }
            this.$emit('change', e.target.checked);
        },
    },
};
